
import React, { useState, useEffect } from 'react'
import { Modal, Button, Input, message } from 'antd';
import { numberParseChina, formatNum } from "@/utils/utils";
import "./saPubPrint.css";
import useGlobalModel from '@/model/globalModel';
import QRCode from 'qrcode.react';
import zh_CN from '@/locale/zh-CN';
import en_US from '@/locale/en-US';
import moment from 'moment';
import NOR from "@/assets/images/nor.png"
// import { useWindowSize } from 'react-use';
//打印

export interface IPrintClumns {
    title: string,
    dataIndex: string,
    colspan?: number,
    render?: (text: string | number, record?: any) => string
}

interface IPrintFieldInfo {
    fieldLabel: string,
    fieldValue?: string | number,
    fieldLabelAlb?: string,
    suffix?: string,
    prefix?: string,
    className?: string,
    empty?: boolean,
    colSpan?: number[],
    rowSpan?: number
}
interface IHeader {
    fieldLabel: string,
    fieldValue?: string | number,
    fieldLabelAlb?: string,
    className?: string,
    border?: boolean,
}
interface IPrintShow {
    header: IHeader[],
    footer: IPrintFieldInfo[],
    totalAmount: IPrintFieldInfo[],
    itemAmount?: IPrintFieldInfo[]
}

interface Item {
    [key: string]: string | number | any
}

export interface IPrintType {
    title?: string,
    type?: string,
    visible: boolean,
    onClose: () => void,
    onConfirm?: () => void,
    itemClumns?: IPrintClumns[], //维修项目字段及信息
    columns: IPrintClumns[],  //商品字段及信息

    itemClumnsAlb?: IPrintClumns[], //维修项目字段及信息alb
    itemClumnsEn?: IPrintClumns[], //维修项目字段及信息en
    columsAlb?: IPrintClumns[],  //商品字段及信息alb
    columsEn?: IPrintClumns[],  //商品字段及信息en



    dataSource: Item[],      //商品数据
    itemDataSource?: Item[],  //维修项目数据
    printShow: IPrintShow    //header 及 footer
    formVal?: any
    pageHeader?: string
}

export function YhPrintSa({
    title = "",
    type = "",
    visible,
    onClose,
    onConfirm = () => null,
    columns,
    itemClumns,
    itemClumnsAlb,
    itemClumnsEn,
    columsAlb,
    columsEn,
    itemDataSource,
    dataSource,
    printShow,
    formVal = {},
    pageHeader = ""
}: IPrintType) {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const [titles, setTieles] = useState<string>(title);
    const [imgSrc, setImgSrc] = useState('');
    useEffect(() => {
        if (formVal) {
            let canvas: any = document.getElementById('qrcode-canvas');
            let data = canvas?.toDataURL('image/png');
            console.log(data)
            setImgSrc(data);
            // canvas = null
        }
    }, [formVal]);

    //设置抬头
    const setTitle = () => {
        let title: string = "";
        Modal.confirm({
            title: '请输入设置的名称',
            content: <Input placeholder="请输入设置的名称" onChange={(e) => { title = e.target.value }} />,
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    if (title) {
                        resolve(title);
                    } else {
                        message.warning("请输入要设置的名称");
                        reject('请输入要设置的名称');
                    }
                }).then(res => {
                    setTieles(res as string);
                });
            },
            onCancel: () => { }
        })
    };

    //打印
    const print = () => {
        const el: HTMLElement | null = document.getElementById('public-print-container');
        const iframe: any = document.createElement('IFRAME');
        let doc = null;
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        // 引入打印的专有CSS样式，根据实际修改
        doc.write(`<LINK rel="stylesheet" type="text/css" href="./saPubPrint1.css">`);
        doc.write(el?.innerHTML);
        doc.close();
        // 获取iframe的焦点，从iframe开始打印
        iframe.contentWindow.focus();
        iframe.onload = () => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        };
        if (navigator.userAgent.indexOf("MSIE") > 0) {
            document.body.removeChild(iframe);
        }
        onConfirm()
    };

    //遍历商品td
    const mapGoods = (goods: Item) => {
        return columsEn?.filter(item => item).map((item, index) => <td key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
    }
    //遍历项目td
    const itemGoods = (goods: Item) => {
        // return itemClumns?.filter(item => item).map((item, index) => <td key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
        return itemClumnsEn?.filter(item => item).map((item, index) => <td colSpan={item.colspan ?? 1} key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
    }
    const qrcodeImgStyle = {
        // border: '1px solid #fff',
        height: '140px',
        width: '140px',
    }
    return (
        <Modal
            title="打印详情"
            width={1300}
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button type="link" onClick={onClose} key="back">{Locale["cancel"]}</Button>,
                <Button type="link" onClick={print} key="submit">{Locale["Confirm printing"]}</Button>,
                <Button type="link" onClick={setTitle} key="setPrintName">{Locale["Settings"]}</Button>
            ]}
        >
            <div id="public-print-container" >
                <div className="print-container">
                    <div className="nor-box">
                        <div className="nor-item">
                            <ul>
                                <li>Nor motors Co Ltd</li>
                                <li>Vat No : 301198769900003</li>
                                <li>Address: Jeddah Bahrah-Old Makkah-Jedddah Road</li>
                            </ul>
                        </div>
                        <div className="nor-img">
                            <img src={NOR} alt="" />
                        </div>
                        <div className="nor-item">
                            <ul>
                                <li className="text-right">شركة نور السيارات المحدودة</li>
                                <li className="text-right">301198769900003: الرقم الضريبي </li>
                                <li className="text-right">العنوان : جده - بحره - طريق جدة مكه القديم</li>
                            </ul>
                        </div>
                    </div>
                    {pageHeader && <h3 style={{ textAlign: 'center' }}>{pageHeader}</h3>}
                    <div className="qrinfo-box">
                        <div className="qrinfo-qr">
                            {formVal && <QRCode
                                style={{ display: 'none' }}
                                id="qrcode-canvas"
                                // level="M"
                                value={formVal}
                                size={135} />}
                            {formVal && <img src={imgSrc} alt="" style={qrcodeImgStyle} />}
                        </div>
                        <div className="qrinfo-info">
                            <ul>
                                {printShow.header && printShow.header.map((item, index) => (
                                    <li className="info-item" key={item.fieldLabel}>
                                        <span className="text-left">{item.fieldLabel}</span>
                                        <span className={`border-span ${item.className ?? ''}`}>{item.fieldValue}</span>
                                        <span className="text-right">{item.fieldLabelAlb}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {itemClumnsAlb && <h3 style={{ textAlign: 'center' }}>Services  الخدمات </h3>}
                    <table className="mingxi">
                        <tbody>
                            <tr className="print-center" >
                                {itemClumnsAlb && itemDataSource && itemDataSource.length > 0 && itemClumnsAlb.filter(item => item).map((item, index) =>
                                    <td key={index} colSpan={item.colspan ?? 1}>{item.title}</td>
                                )}
                            </tr>
                            <tr className="print-center" >
                                {itemClumnsEn && itemDataSource && itemDataSource.length > 0 && itemClumnsEn.filter(item => item).map((item, index) =>
                                    <td key={index} colSpan={item.colspan ?? 1}>{item.title}</td>
                                )}
                            </tr>
                            {itemDataSource && itemDataSource.length > 0 &&
                                itemDataSource.map((item, index) =>
                                    <tr key={index} className="print-center">
                                        {itemGoods(item)}
                                    </tr>
                                )}


                            {printShow.itemAmount && itemDataSource && itemDataSource?.length > 0 &&
                                printShow.itemAmount.map((item, index) =>
                                    <tr key={index} style={{ height: "25px" }}>
                                        <td className={item.className} colSpan={2}>
                                            {item.fieldLabel ? item.fieldLabel + "：" : ""}
                                        </td>
                                        <td className={item.empty ? item.className : ''} colSpan={3}>{item.empty ? "" : `${item.prefix ?? ""}${formatNum(item.fieldValue)}${item.suffix ?? ""}`}</td>
                                        <td className={item.className} colSpan={1}>{item.fieldLabelAlb}</td>
                                    </tr>
                                )}

                        </tbody>
                    </table>
                    <h3 style={{ textAlign: 'center' }}>Spare Parts  قطع الغيار </h3>
                    <table className="mingxi">
                        <tbody>
                            <tr className="print-center columns-header" >
                                {columsAlb && columsAlb.filter(item => item).map((item, index) =>
                                    <td key={index}>{item.title}</td>
                                )}
                            </tr>
                            <tr className="print-center columns-header" >
                                {columsEn && columsEn.filter(item => item).map((item, index) =>
                                    <td key={index}>{item.title}</td>
                                )}
                            </tr>
                            {dataSource && dataSource.length > 0 &&
                                dataSource.map((item, index) =>
                                    <tr key={index} className="print-center">
                                        {mapGoods(item)}
                                    </tr>
                                )}

                            {printShow.totalAmount &&
                                printShow.totalAmount.map((item, index) =>
                                    <tr key={index} style={{ height: "25px" }}>
                                        <td className={item.className} colSpan={item.colSpan?.[0] ?? 2} >
                                            {item.fieldLabel ? item.fieldLabel + "：" : ""}
                                        </td>
                                        <td className={item.empty ? item.className : ''} colSpan={item.colSpan?.[1] ?? 3}>{item.empty ? "" : `${item.prefix ?? ""}${formatNum(item.fieldValue)}${item.suffix ?? ""}`}</td>
                                        <td className={item.className} colSpan={item.colSpan?.[2] ?? 2}>{item.fieldLabelAlb}</td>
                                    </tr>
                                )}
                        </tbody>
                    </table>
                    <ul className="footer">
                        {printShow.footer && printShow.footer.map((item, index) => <li className={item.className ?? ""} key={index}>{item.fieldLabel + '：' + item.fieldValue}</li>)}
                    </ul>
                    <ul className="page-footer">
                        <li>Nor Motors Co Alhli AlSaudi Bank ACC No <br />IBAN NO </li>
                        <li> 04949742000101 <br />SA8310000004949742000101</li>
                        <li>حساب شركة نور السيارات المحدودة بالبنك الاهلى السعودى <br />الايبان</li>
                    </ul>
                </div>

            </div>
        </Modal>
    )
};
